import { Box, Typography, TypographyProps } from "@mui/material";
import { mergeSx } from "src/utils/styles";
import { centerContent, dFlex, flex1 } from "src/styles/sx";

export const CenteredTypography = (props: TypographyProps) => {
	return (
		<Box sx={mergeSx(dFlex, flex1, centerContent)}>
			<Typography {...props} />
		</Box>
	);
};
